import { render, staticRenderFns } from "./ExtruderMoves.vue?vue&type=template&id=5c398e08&"
import script from "./ExtruderMoves.vue?vue&type=script&lang=ts&"
export * from "./ExtruderMoves.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports